export default "__VITE_ASSET__DKkQK6vg__"